module.exports = __webpack_public_path__ + "img/pay-failed.73fecff5.png";